const BaseModule = require('../../../../90_utils/base/BaseModule');
const HorizontalGraph = require('../../../../80_bits/horizontal-graph/script');

class HorizontalGraphBlock extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$graph = this.$el.find('.horizontal-graph');
		this.graph = new HorizontalGraph(this.$graph);

		this.graphData = {};
		this.isFirstBuild = true;
	}

	// basemodule methods

	_domReady(){
		this._rebuild();
	}

	_addListeners(){ }
	_removeListeners(){ }

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }

	// graph construction

	_rebuild(){

		if(this.isFirstBuild){
			this._retrieveData();
			this._rebuildGraph();
		}
	}

	_retrieveData(){
		// will need to rebuild if graph is ever in a tab
		// otherwise, graph itself will pull data
	}

	_rebuildGraph(){

		// graph will build itself - will need to re-enable if graph is ever in a tab

		// if(this.graphData && this.graphData.dataPoints.length){
		// 	this.graph.swapData(this.graphData);
		// }
	}

	_showNewGraph(){

	}

	_hideOldGraph(){

	}
}

module.exports = HorizontalGraphBlock;
